"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var CartContext_1 = require("./CartContext");
var UpsellItem_1 = require("./UpsellItem");
var bestSellerHandles = [
    'uro-vaginal-probiotic-capsules',
    'flo-pms-vitamin-capsules',
    'meno-menopause-vitamin-capsules',
];
var EmptyCart = function () {
    var _a = (0, hooks_1.useContext)(CartContext_1.default), allProducts = _a.allProducts, handleSlide = _a.handleSlide, isCartPage = _a.isCartPage;
    var handleCtaClick = function () {
        if (!isCartPage) {
            handleSlide();
        }
        else {
            window.location.href = '/collections/shop-all';
        }
    };
    return ((0, preact_1.h)("div", { class: "cart-empty" },
        (0, preact_1.h)("div", { class: "cart-empty-container" },
            (0, preact_1.h)("p", { class: "cart-empty__header" }, "Your cart is empty :("),
            (0, preact_1.h)("button", { onClick: handleCtaClick, class: "button button--hot-orange" }, "Resume Shopping"),
            (0, preact_1.h)("div", null,
                (0, preact_1.h)("a", { class: "cart-empty__shop-all", href: "/collections/shop-all" }, "Shop All"))),
        (0, preact_1.h)("div", { class: "cart-empty-best-sellers" },
            (0, preact_1.h)("p", { class: "cart-section__additional-products-header" }, "Explore our best-sellers:"),
            bestSellerHandles.map(function (handle) { return ((0, preact_1.h)(UpsellItem_1.default, { prod: allProducts.find(function (product) { return product.handle === handle; }) })); }))));
};
exports.default = EmptyCart;
